'use client'

import React from 'react'

import type { Props as MediaProps } from '@/types/Media'
import { cn } from '@/utilities/ui'
import { Media } from '@/payload-types'
import { Button } from '../../ui/Button'

export const PdfMedia: React.FC<MediaProps> = (props) => {
  const { resource, className } = props

  const url = ((resource as Media)?.url || '') as string

  if (resource && typeof resource === 'object' && url && typeof url === 'string') {
    return (
      <div className="flex flex-col mb-5 justify-center">
        <object
          data={`${url}#toolbar=0`}
          type="application/pdf"
          className={cn('w-[65%] mx-auto h-160', className)}
        >
          <p>
            Your browser does not support PDFs.
            <a href={url}>Download the PDF</a>.
          </p>
        </object>
        <Button variant="default" className="w-fit mx-auto mt-4">
          <a href={url}>Télécharger le menu</a>
        </Button>
      </div>
    )
  }

  return null
}
